<template>
	<div class="sticky-box">
		<!-- @slot Used to display Deatils  -->
		<slot name="detail" />
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * Sticky Box
 */
export default defineComponent({
	name: "StickyBox"
});
</script>
<style lang="scss">
div.sticky-box {
	background-color: var(--dashboard-element-light);
	z-index: 102;
	border: 1px solid var(--dashboard-element);
	border-radius: 4px;
	// min-height: 200px;
	// height: auto;
	padding: 8px 16px;
	bottom: 0px;
	position: fixed;

	// iterating over slideup states
}
</style>
